import { inject, Pipe, PipeTransform } from '@angular/core';
import { LookupsService } from '@web/csl-lib-services';

// This pipe is used to get the value of a lookup based on the id and primary value
@Pipe({
  name: 'lookup',
  standalone: true
})
export class LookupPipe implements PipeTransform {

  lookupService: LookupsService

  constructor() {
    this.lookupService = inject(LookupsService);
  }

  transform(value: number, lookupType: string): string | undefined {

    switch(lookupType) {
      case 'healthRecordDocumentTypes':
        return this.lookupService.healthRecordDocumentTypes.find(l => l.value === value)?.name ?? 'Unknown';
      case 'lgStatusDescription':
        return this.lookupService.legalGuardianStatus.find(l => l.value === value)?.description ?? 'Unknown';
      case 'lgStatusName':
        return this.lookupService.legalGuardianStatus.find(l => l.value === value)?.name ?? 'Unknown';
      case 'mrrStatus':
        return this.lookupService.mrrStatus.find(l => l.value === value)?.description ?? 'Unknown';
      case 'mrrStatusName':
        return this.lookupService.mrrStatus.find(l => l.value === value)?.name ?? 'Unknown';
      case 'otStatusName':
        return this.lookupService.ownerTransferStatus.find(l => l.value === value)?.name ?? 'Unknown';
      case "otEventTypeDescription":
        return this.lookupService.ownerTransferEventTypes.find(l => l.value === value)?.description ?? 'Unknown';
      case 'scpUploadWorklistStatus':
        return this.lookupService.scpUploadWorklistStatus.find(l => l.value === value)?.name ?? 'Unknown';
      case 'sharingPrivilegeLevels':
        return this.lookupService.sharingPrivilegeLevels.find(l => l.value === value)?.name ?? 'Unknown';
      case 'sharingStatus':
        return this.lookupService.sharingStatus.find(l => l.value === value)?.name ?? 'Unknown';
      case 'shareeRoles':
        return this.lookupService.shareeRoles.find(l => l.value === value)?.name ?? 'Unknown';
      case 'ownerRelationship':
        return this.lookupService.ownerRelationships.find(l => l.value === value)?.name ?? 'Unknown';
      default:
        return 'Unknown';
    }

  }

}
